import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Guide20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.00006 11.5607L8.03039 8.53032L6.96973 7.46966L5.00006 9.43933L4.03039 8.46966L2.96973 9.53032L5.00006 11.5607Z'
      fill='currentColor'
    />
    <path
      d='M16.6818 8.2276C17.0837 8.12714 17.328 7.71994 17.2275 7.31809C17.1271 6.91624 16.7199 6.67192 16.318 6.77239L12.318 7.77239C11.9162 7.87285 11.6719 8.28005 11.7723 8.68189C11.8728 9.08374 12.28 9.32806 12.6818 9.2276L16.6818 8.2276Z'
      fill='currentColor'
    />
    <path
      d='M17.2275 11.3181C17.328 11.7199 17.0837 12.1271 16.6818 12.2276L12.6818 13.2276C12.28 13.3281 11.8728 13.0837 11.7723 12.6819C11.6719 12.28 11.9162 11.8728 12.318 11.7724L16.318 10.7724C16.7199 10.6719 17.1271 10.9162 17.2275 11.3181Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.17372 1.7704L10 3.8719L18.8263 1.7704C19.2902 1.65996 19.75 2.02317 19.75 2.5V15.3571C19.75 15.7044 19.5116 16.0063 19.1737 16.0868L10.1737 18.2296C10.0595 18.2568 9.9405 18.2568 9.82628 18.2296L0.826285 16.0868C0.488434 16.0063 0.25 15.7044 0.25 15.3571V2.5C0.25 2.02317 0.709849 1.65996 1.17372 1.7704ZM1.75 3.44954V14.7648L9.25 16.5505L9.25 5.23526L1.75 3.44954ZM18.25 14.7648L10.75 16.5505L10.75 5.23526L18.25 3.44954V14.7648Z'
      fill='currentColor'
    />
  </Svg>
);

Guide20.displayName = 'Guide20';
export default Guide20;
